import { TransportData } from "@app/classes/infrastructure/transportdata";
import { TodaysTaskFetchRequest } from "./todaystasklistfetchrequest";
import { DataContainerService } from "@app/classes/infrastructure/datacontainer.service";

export class TodaysTask {
  public static readonly EmbedCollectionName: string = "todays_task_summery";

  FetchRequest: TodaysTaskFetchRequest = null as any;

  public as_on_date: string = "";
  public as_on_date_formatted: string = "";

  public name_en: string = "";
  public name_mr: string = "";
  public total_count: string | number = 0;
  public display_order: number = 0;
  public from_entity_type: number = 0;

  public static FromTransportData(td: TransportData): TodaysTask[] {
    const result: TodaysTask[] = [];
    const dcs = DataContainerService.GetInstance();

    if (dcs.CollectionExists(td.MainData, TodaysTask.EmbedCollectionName)) {
      const coll = dcs.GetCollection(td.MainData, TodaysTask.EmbedCollectionName)!;
      for (const data of coll.Entries) {
        result.push(data as TodaysTask);
      }
    }
    return result;
  }
}

export { TodaysTask as TodaysTaskResponseView, TodaysTask as todays_task_response_view };